// Lazy loading. Needed for safari 10
import 'intersection-observer'

// Hide focus on click but not tab. Needed for all browsers
import 'focus-visible'
